import { Button } from "../../../cta_utils/AnButton";
import { AnConfirmPopup } from "../../../cta_utils/AnConfirmPopup"
import AnPopup from "../../../cta_utils/AnPopup";
import { clear_suggestions } from "../api";
import { ALL_MAPPER_ACTIONS } from "../reducers/TempMapperReducer";

export const ClearSuggestionPopup = ({pageDataReducer, handlePopupClose}) => {
    const handleClearMapperSuggestions = (clear_mapped = false) => {
        clear_suggestions({clear_mapped: clear_mapped}).then((response) => {
            pageDataReducer({type: ALL_MAPPER_ACTIONS['SET_STATE'], payload: {successMessages:{
                message: "Suggestions cleared",
                duration: 3000
            }}})
            handlePopupClose();
        })
    }
    return(
        <AnPopup name="exportPopup" handleOnClosePopup={() => {handlePopupClose();}} maxWidth={480}>
          <div className="text_title" style={{marginBottom: 16, textAlign: 'center'}}>Do you want to clear suggestions?</div>
          
          <div style={{display: 'flex', marginTop: 16, alignContent: 'center', justifyContent: 'center'}}>
            <Button buttonSize="Medium" buttonStyle={{width: 'max-content'}} innerButtonStye={{padding: '8px 20px'}}
                    onClick={() => {handleClearMapperSuggestions()}}>Clear All</Button>
            <Button buttonSize="Medium" buttonStyle={{width: 'max-content', marginLeft: 16}} innerButtonStye={{padding: '8px 20px'}}
                    onClick={() => {handleClearMapperSuggestions(true)}}>Clear Mapped</Button>
            <Button type="Secondary" buttonSize="Medium" buttonStyle={{width: 'max-content', marginLeft: 16}} innerButtonStye={{padding: '8px 20px'}}
                    onClick={() => {handlePopupClose();}}>Cancel</Button>
          </div>
        </AnPopup>
        
        )
}